module.exports = __webpack_public_path__ + "f38358575913a8bcdf8dba68330614f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/www/images/coffee-break.png
// module id = 3710
// module chunks = 2